import { Mui, MuiIcons } from "@osu/react-ui";
import ExternalLinkIcon from "./ExternalLinkIcon";

function ScholarsDashboardLink({ ...rest }) {
  return (
    <Mui.Button
      variant="contained"
      color="primary"
      startIcon={<MuiIcons.School />}
      component={Mui.Link}
      href="https://go.osu.edu/scholars"
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      Scholars Applicant Dashboard{" "}
      <ExternalLinkIcon color="inherit" />
    </Mui.Button>
  );
}

export default ScholarsDashboardLink;
